module.exports = __webpack_public_path__ + "img/gal-2.5f14c82e.jpg";